<template>
  <div>
      <div class="mb-3">
              <form>
                  <label>{{'import_students_notice' | setText('Импорт учеников EXCEL. После загрузки документа - операция добавления учеников может занять от 1 минуты до 5')}}</label> <br/>
                  <input ref="fileupload" type="file" @input="importItem" accept=".xlsx"></input>
              </form>
        </div>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";
export default {
  components: {

  },
  data() {
    return {
        item:null
    };
  },
  name: "paper-table",
  props: {
   
  },
  computed: {
   
  },
  methods: {
    importItem(event){
        this.$loading(true);
       let bodyFormData = new FormData();
        bodyFormData.append('_method', 'POST');
        bodyFormData.append(`import_file`,  event.target.files[0]);
         return this.$http
    ({
      url: `business/clients`,
      method: 'POST',
      data: bodyFormData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "api-version": "1",
        "platform": "web"
      }
    })
    .then((response) => {

      this.$notify({
        title: "Импорт",
        message: this.$store.state.text['import_students_notice'],
        icon: "ti-save",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success",
      });

      return response.data.data;

    })
    .catch((error) => {
      errorNotify(error, this.$notify);
      return null;
    })
    .finally(() => {
      setTimeout(() => {
        this.$refs.fileupload.value = null
        this.$loading(false);
      }, 400);
    });
    }
  },
};
</script>